<template>
  <header
    class="bg-surface-light border-b border-surface-grey sticky top-0 z-50"
  >
    <GlobalBanner />
    <BaseContainer>
      <div class="flex justify-between h-20 items-center">
        <RouterLink
          to="/"
          class="flex-shrink-0 flex items-center w-25 h-8 lg:w-50 lg:h-12"
        >
        <GlobalCustomerLogo />
        </RouterLink>

        <nav class="hidden md:flex justify-center h-full w-full">
          <div class="space-x-2 flex">
            <BaseDropdown
              v-if="!hideCategories"
              ref="categoryDropdownRef"
              class="hidden md:inline-flex"
              :text="$t('globals.categories')"
              @on-change="() => closeOtherDropdowns('category')"
            >
              <CategoryFilter
                @on-change="categoryDropdownRef?.closeDropdown()"
              />
            </BaseDropdown>

            <BaseDropdown
              v-if="!hasSpecialCategories && !hideVenues"
              ref="locationDropdownRef"
              class="hidden md:inline-flex"
              :text="$t('globals.locations')"
              @on-change="() => closeOtherDropdowns('location')"
            >
              <LocationFilter
                @on-change="locationDropdownRef?.closeDropdown()"
              />
            </BaseDropdown>

            <BaseDropdown
              v-if="hasSpecialCategories"
              ref="specialCategoryDropdownRef"
              class="hidden md:inline-flex"
              :text="specialCategoryLabel"
              @on-change="() => closeOtherDropdowns('specialCategory')"
            >
              <SpecialCategoryFilter
                @on-change="specialCategoryDropdownRef?.closeDropdown()"
              />
            </BaseDropdown>

            <BaseDropdown
              v-if="!hideCalendar"
              ref="dateDropdownRef"
              class="hidden md:inline-flex"
              :text="$t('globals.date')"
              @on-change="() => closeOtherDropdowns('date')"
            >
              <DateFilter @on-change="dateDropdownRef?.closeDropdown()" />
            </BaseDropdown>
          </div>
        </nav>

        <div class="flex items-center justify-center gap-2 lg:gap-4">
          <GlobalSearch v-if="!hideSearch" />
          <GlobalSearchFilter />
          <GlobalCart />
          <GlobalLogin />
        </div>
      </div>
    </BaseContainer>
  </header>
  <GlobalWelcomeBar />
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  import CategoryFilter from '@/components/filters/CategoryFilter.vue';
  import DateFilter from '@/components/filters/DateFilter.vue';
  import LocationFilter from '@/components/filters/LocationFilter.vue';
  import SpecialCategoryFilter from '@/components/filters/SpecialCategoryFilter.vue';
  import BaseDropdown from '@/components/ui/BaseDropdown.vue';
  import { useGeneralStore } from '@/stores/general';

  import BaseContainer from '../ui/BaseContainer.vue';
  import GlobalBanner from './GlobalBanner.vue';
  import GlobalCart from './GlobalCart.vue';
  import GlobalCustomerLogo from './GlobalCustomerLogo.vue';
  import GlobalLogin from './GlobalLogin.vue';
  import GlobalSearch from './GlobalSearch.vue';
  import GlobalSearchFilter from './GlobalSearchFilter.vue';
  import GlobalWelcomeBar from './GlobalWelcomeBar.vue';

  const generalStore = useGeneralStore();
  const hasSpecialCategories = computed(() => (generalStore.customer()?.special_categories ?? 0) > 0);
  const specialCategoryLabel = computed(() => generalStore.customer()?.special_category_name ?? '');
  const hideCategories = computed(() => generalStore.customer()?.hide_categories ?? false);
  const hideVenues = computed(() => generalStore.customer()?.hide_venues ?? false);
  const hideCalendar = computed(() => generalStore.customer()?.hide_calendar ?? false);
  const hideSearch = computed(() => generalStore.customer()?.hide_search ?? false);

  const categoryDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(
    null
  );
  const locationDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(
    null
  );
  const specialCategoryDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(
    null
  );
  const dateDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(null);


  function closeOtherDropdowns(except: string) {
    if (except !== 'category' && categoryDropdownRef.value) {
      categoryDropdownRef.value.closeDropdown();
    }
    if (except !== 'location' && locationDropdownRef.value) {
      locationDropdownRef.value.closeDropdown();
    }
    if (except !== 'specialCategory' && specialCategoryDropdownRef.value) {
      specialCategoryDropdownRef.value.closeDropdown();
    }
    if (except !== 'date' && dateDropdownRef.value) {
      dateDropdownRef.value.closeDropdown();
    }
  }
</script>
